// A cancelled renewal retains access only until its verified paid-through date.
export const PAID_STATUSES = ['active', 'cancelled', 'cancellation_pending', 'completed', 'payment_failed', 'past_due', 'halted', 'suspended'];

export const toDate = (value) => {
  if (!value) return null;
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
};

export const hasPaidAccess = (profile, now = new Date()) => {
  const end = toDate(profile?.subscriptionEndDate);
  return ['pro', 'business'].includes(profile?.plan)
    && PAID_STATUSES.includes(profile?.subscriptionStatus)
    && Boolean(end && end > now);
};

export const FREE_PLAN_LIMITS = { maxRecipes: 10, maxIngredients: 30, maxBatches: 5 };
